module.exports = __webpack_public_path__ + "static/media/close.ffcccd8e.svg";